import { FormInput, FormSelect } from '../../../../component/input/InputStyle';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import FormLabel from '../../../../component/input/FormLabel.component';
import Component from '../interfaces/Component';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../component/buttton/Button.component';
import { FormInterface } from '../interfaces/Form';
import MenuItem from '@material-ui/core/MenuItem';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';

export default function Form({ handleClick, handleSubmitForm, request, componentType }: FormInterface) {

    const { handleSubmit, handleChange, values, isSubmitting } = useFormik<Component>({
        initialValues: INITIAL_VALUES,
        onSubmit: values => {
            handleSubmitForm && handleSubmitForm(values);
        },
    });

    return (
        <form onSubmit={handleSubmit}>
            <GridComponent justify="flex-start" alignItems="center" spacing={2} >
                <FormLabel title="Nome do componente" sm={12} >
                    <FormInput
                        name="nome"
                        value={values.nome}
                        onChange={handleChange}
                        required
                    />
                </FormLabel>
                <FormLabel title="tipo" sm={12} >
                    <FormSelect
                        name="tipo_componente_id"
                        value={String(values.tipo_componente_id)}
                        onChange={handleChange}
                        defaultValue='0'
                        required
                    >
                        <MenuItem value={'0' || ''} disabled>Selecione</MenuItem>

                        {componentType.map((type: any, index: number) => {
                            return <MenuItem value={type.id || index} key={index}>{type.nome}</MenuItem>
                        })}
                    </FormSelect>
                </FormLabel>
                <Grid item xs={6}>
                    <Button title="Salvar" fullWidth disabled={isSubmitting && request} />
                </Grid>
                <Grid item xs={6}>
                    <Button type="button" title="Voltar" color="secondary" fullWidth onClick={handleClick} />
                </Grid>
            </GridComponent>
        </form>
    )
}